import React, { useState } from 'react';
import './Flashcard.css';

interface FlashCardProps {
  front: React.ReactNode;
  back: React.ReactNode;
  isFlipped?: boolean;
  onFlip?: () => void;
  width?: number | string;
  height?: number | string;
}

const FlashCard: React.FC<FlashCardProps> = ({ front, back, isFlipped: externalIsFlipped, onFlip, width, height }) => {
  const [internalIsFlipped, setInternalIsFlipped] = useState(false); // Show front by default
  const isFlipped = externalIsFlipped !== undefined ? externalIsFlipped : internalIsFlipped;

  const handleClick = () => {
    if (onFlip) {
      onFlip();
    } else {
      setInternalIsFlipped(!internalIsFlipped);
    }
  };

  return (
    <div
      className={`flashcard${isFlipped ? ' flipped' : ''}`}
      onClick={handleClick}
      style={{
        width: width ?? 320,
        height: height ?? 200,
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <div className="flashcard-inner">
        <div className="flashcard-front">
          {front}
        </div>
        <div className="flashcard-back">
          {back}
        </div>
      </div>
    </div>
  );
};

export default FlashCard;